import {useState} from 'react';
import {Row, Col, Tabs, Tab, Button} from 'react-bootstrap';
import ActionBar from '../actionBar';
import { gql } from '@apollo/client';
import { useQuery } from "@apollo/client/react";
import SupportTab from './supportTab';
import SiteInformationTab from './siteInformationTab';
import ConfigTab from './configTab';
import FeatureToggles from './featureToggles';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';
import {useAtom} from 'jotai';
import {selectedTabRecoil} from '../recoil';
import {useCustomerContext} from '../../lib/context/customerContext';

// Static — hoisted so it's the same reference every render
const ACCOUNT_CONTEXT_FILTERS = {
  field: 'with.account_configuration',
  value: '1'
};

export const Account = props => {
  const [modalTrigger, setModalTrigger] = useState(false);
  const [activeKey, setActiveKey] = useAtom(selectedTabRecoil);
  const {hasPermission} = useCustomerContext();
  const {data: featureEnabledDisbled} = useQuery(CUSTOMER_FEATURES);
  const {data: accountContext} = useQuery(ACCOUNT_CONTEXT, {
    variables: { filters: ACCOUNT_CONTEXT_FILTERS }
  });

  //Customer Features reducer
  const enabledCustomerFeatures = featureEnabledDisbled?.CustomerFeatures?.result?.reduce((acc, feat) => {
    if (feat.customer_enabled === true) {
        acc.push(feat.feature_code)
    }
    return acc;
  }, [] )

  const config = accountContext?.SelfCustomerAccount?.result?.[0]?.account_configuration;

  const handleModal = (e) => {
    setModalTrigger(!modalTrigger);
  }
  
  return (
    <>
      <ActionBar showHidden={false} showSearchBar={true} showSearchInput={false} title="Account">
        {/* RBAC: SUPPORT_SUBMIT_TICKET - "Disable 'Create a support ticket' button" */}
        <Button data-testid="create-ticket-button" disabled={!hasPermission('SUPPORT_SUBMIT_TICKET')} className="ms-3" defaultkey={0} onClick={handleModal}>Create a Support Ticket</Button>
      </ActionBar>
      <div id="privoro-tabs">
        <Row>
          <Col>
            {/* RBAC: FEATURE_VIEW/CONFIG_VIEW have no listed treatment in the
                sheet - applying the default VIEW-hide rule. IMPORTANT: react-
                bootstrap's Tabs reads `eventKey`/`title` directly off each
                Tab child's props (same pattern that broke Portal's Accordion
                earlier) - so tab visibility MUST use a plain conditional,
                never wrap a <Tab> in <Can>, or the tab will silently lose
                its header/selectability the same way. */}
            <Tabs
              className="mb-3"
              activeKey={activeKey}
              onSelect={(e) => setActiveKey(e)}
            >
              <Tab eventKey="support" title="Support">
                <SupportTab
                  modaltrigger={modalTrigger}
                  change={setModalTrigger}
                />
              </Tab>

              {hasPermission('CONFIG_VIEW') &&
                <Tab eventKey="configuration" title="Configuration">
                  <ConfigTab config={config} active={enabledCustomerFeatures} />
                </Tab>
              }

              {hasPermission('FEATURE_VIEW') &&
                <Tab eventKey="features" title="Features">
                  <FeatureToggles config={config} active={enabledCustomerFeatures} />
                </Tab>
              }

              {/* No permission code exists for Site Information in the RBAC
                  sheet - left ungated, same gap noted for Account overall. */}
              <Tab eventKey="site" title="Site Information">
                <SiteInformationTab />              
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </div>
    </>
  );
};

const ACCOUNT_CONTEXT = gql`
query getAccountContext($filters: GenericFilters) {
  SelfCustomerAccount(filters: $filters) {
    result {
      description
      name
      root
      account_configuration {
        mdm_lostmode_msg
        mdm_lostmode_phone
        mdm_client_id
        mdm_client_secret
        mdm_tenant_id
        co_timer
        grace_period
        alarm_freq
      }
    }
  }
}
`;

const CUSTOMER_FEATURES = gql`
  query getCustomerFeaturesContext {
    CustomerFeatures {
      result {
        id
        account_id
        feature_code
        customer_enabled
      }
    }
  }
`;

export default compose(
  withAlerts
)(Account);
